// The one home of the free-article allowance. A plain module (no "use client",
// no server-only imports) so both halves of the meter read the same number:
// the server rule in ./meter-cookie.ts, which the enforcing proxy and the
// entitlement route share, and the client mirror that renders the wall and the
// "N more free articles" notice (./meter.ts).

/** Articles a reader gets free each calendar month before the subscription
 * wall. 10 is Google's own flexible-sampling starting point. */
export const FREE_ARTICLE_LIMIT = 10
